export { LoginPage as default } from 'src/modules/Login';
